import axios from 'axios'
import store from '../store'
import { Notification } from 'element-ui'

const apiClient = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? '/proxyapi/' : '/base_victory/hs/siteapi/',
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })

function extractMethodName(url) {
  const methodNameExtractor = /\/(?<methodName>\w+)(\?.*)?$/
  const { methodName } = url.match(methodNameExtractor).groups

  return methodName
}

apiClient.interceptors.request.use(config => {
  const methodName = extractMethodName(config.url)

  store.dispatch('startLoading', methodName)
  return config
})

apiClient.interceptors.response.use(
  response => {
  const methodName = extractMethodName(response.config.url)
  store.dispatch('doneLoading', methodName)
  return response
}, error => {
  if (error.response) {
    const methodName = extractMethodName(error.response.config.url)
    store.dispatch('doneLoading', methodName)

    if (error.response.status === 401) {
      store.dispatch('logout')

      Notification({
        title: 'Сессия истекла',
        message: error.response.data.errorMessage || 'Требуется авторизация',
        type: 'error'
      })
    } else {
      Notification({
        title: 'Ошибка сервера',
        message: error.response.data.errorMessage || 'Попробуйте еще раз или обратитесь в техподдержку портала',
        type: 'error'
      })
    }
  }
  return Promise.reject(error)
})

export default apiClient